import { api_GET, api_POST, api_PUT } from "./_api.js";

const infracoes_api = {
    getList: (tipofiscalizacao_id = null) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Infracao/GetList/${tipofiscalizacao_id ?? ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListAtivos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Infracao/GetListAtivos")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Infracao/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetConsultaInfracao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Infracao/GetConsultaInfracao", json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetEtapasPercorridas: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracao/GetEtapasPercorridas/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItemFiscalizacaoInfracao: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracao/GetItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetItemFiscalizacaoHash: (hash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracao/GetItemInfracao/${hash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetListEtapaTipoFiscalizacaoInfracao: (etapa, tipoFiscalizacao) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Infracao/GetListEtapaTipoFiscalizacaoInfracao/${etapa}/${tipoFiscalizacao}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (Infracao) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Infracao", Infracao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (Infracao) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("Infracao", Infracao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetImpressaoItensDisponiveis: (hash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracao/ImpressaoItensDisponiveis/${hash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetImpressaoDocumentoSeparadoPng: (hash, parametrizacaoHash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracao/ImpressaoDocumentoSeparadoPng/${hash}/${parametrizacaoHash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetImpressaoItemPngCompleta: (hash, parametrizacaoHash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracao/ImpressaoItemPngCompleta/${hash}/${parametrizacaoHash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetImpressaoItemHtml: (hash, parametrizacaoHash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracao/ImpressaoItemHtml/${hash}/${parametrizacaoHash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetImpressaoItemDadosRoc: (hash, parametrizacaoHash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`FiscalizacaoInfracao/ImpressaoItemDadosRoc/${hash}/${parametrizacaoHash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PutAlteracaoEmail: (fiscalizacaoInfracao) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("FiscalizacaoInfracao/PutAlteracaoEmail", fiscalizacaoInfracao)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    AgendarReajuste: (reajuste) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("Infracao/AgendarReajuste", reajuste)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetReajusteItens: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Infracao/GetReajusteItens/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    CancelarReajuste: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`Infracao/CancelarReajuste/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getVerificacaoReajustePendente: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("Infracao/VerificacaoReajustePendente")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    GetReajustes: (tipoFiscalizacao_Id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Infracao/GetReajustes/${tipoFiscalizacao_Id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    ExportCSVInfracoes: (tipofiscalizacao_id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`Infracao/ExportCSVInfracoes/${tipofiscalizacao_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default infracoes_api;